import {
  inquiryList,
  inquiryFilterList,
  inquiryListConfig,
  setInquiryListColumnWidth,
  getView
} from '@/services/inqueryServices'
import _ from 'lodash'
import { toType } from '@/lib/utils'
import i18n from '@/lib/language'
const defaultTit = [
  { code: 160 }, // 编号
  { input_time: 160 }, // 录入时间
  { audit_status: 88 }, // 审核状态
  { dev_userid: 108 }, // 开发人员
  { input_userid: 108 }, // 录入人员
  { audit_userid: 108 }, // 审核人员
  { follow_userid: 108 }, // 跟进人员
  { dev_groupid: 108 }, // 开发团队
  { input_groupid: 108 }, // 录入团队
  { audit_groupid: 108 }, // 审核团队
  { follow_groupid: 108 }, // 跟进团队
  { from_info: 160 }, // 来源信息
  { last_followup_time: 160 }, // 上次回访时间
  { next_followup_time: 160 }, // 下次回访时间
  { followup_remind_time: 160 }, // 回访提醒时间
  { base_info_info_level: 108 }, // 信息分级
  { base_info_info_type: 108 }, // 信息类型
  { base_info_info_status: 108 }, // 信息状态
  { base_info_info_plan: 108 }, // 推广方式
  { contact_info_company_name: 160 }, // 公司名称
  { contact_info: 126 }, // 联系人
  { archive_time: 160 } // 归档时间
]
const getWidth = field => {
  let tbWidth = 0
  const key = field.fieldkey
  const type = field.fieldtype
  let keyname = ''
  for (let i = 0; i < defaultTit.length; i++) {
    if (key === Object.keys(defaultTit[i])[0]) {
      tbWidth = Object.values(defaultTit[i])[0]
      keyname = key
    }
  }
  if (!keyname && type) {
    switch (type) {
      case 'radio':
      case 'radioinfo_payfor':
      case 'radioinfo_type':
      case 'radioinfo_followup':
      case 'select':
        tbWidth = 88
        break
      case 'radioinfo_level':
        tbWidth = 108
        break
      case 'datetime':
      case 'text':
      case 'ip':
      case 'number':
      case 'phone':
      case 'email':
      case 'area':
        tbWidth = 160
        break
      case 'select_tree':
      case 'checkbox':
        tbWidth = 280
        break
      default:
        tbWidth = 88
        break
    }
  }

  return tbWidth
}

const state = {
  loading: true,
  titles: {},
  list: [],
  tableSort: {
    sortfieldtype: '',
    sortkey: 'code',
    sorttype: 2
  },
  sortedInfo: {},
  pagination: {
    currentPage: 1,
    pageSize: 10,
    pageSizes: ['10', '20', '30', '50'],
    total: 0,
    allCount: 0
  },
  // 列表搜索中的code参数
  code: '',
  // 搜索条件
  searchConfig: {
    key: '',
    placeholder: '',
    value: '',
    options: []
  },
  viewTabs: []
}

const getters = {
  newList (state) {
    const { list = [] } = state
    if (!list.length) return

    let data = _.cloneDeep(list)
    data.forEach(item => {
      for (let k in item) {
        if (toType(item[k]) === 'object' && !item[k].columntype) {
          if (item[k].fieldvalue === '') {
            item[k] = '- -'
          } else {
            item[k] = item[k].fieldvalue
          }
        } else {
          if (item[k] === '') {
            item[k] = '- -'
          }
        }
      }
    })
    return data
  },
  columnsData (state) {
    const { titles = {}, list = [] } = state
    let newArr = []
    let allWidth = 0
    for (let fieldkey in titles) {
      const fieldTitle = titles[fieldkey].fieldname
      const fieldtype = titles[fieldkey].fieldtype
      let field = {}

      field.dataIndex = fieldkey
      field.fieldtype = fieldtype
      field.title = fieldTitle
      field.sortkey = titles[fieldkey].sortkey
      field.width = titles[fieldkey].width || getWidth(titles[fieldkey])
      field.defaultWidth = getWidth(titles[fieldkey])
      field.minWidth = 88
      // console.log(fieldkey, getWidth(titles[fieldkey]), field.width)
      allWidth += field.width

      for (let item of list) {
        for (let k in item) {
          if (k === fieldkey) {
            field.scopedSlots = { customRender: fieldkey }
            if (item[k] && item[k].columntype === 'info_level') {
              if (item[k].type === 2) {
                let width = item[k].level * 16 + 32 < 108 ? 108 : item[k].level * 16 + 32
                if (field.width < width) {
                  field.width = width
                }
                field.minWidth = width
              } else {
                field.minWidth = 108
              }
            }
          }
        }
      }
      if (field.sortkey) {
        // field.sorter = (a, b) => a[field.dataIndex] - b[field.dataIndex]
        field.sorter = true
        if (field.fieldtype !== 'radioinfo_level') {
          field.minWidth = 108
        }
        field.width = field.width < 108 ? 108 : field.width
        // console.log(field)
        // if (JSON.stringify(state.tableSort) !== '{}' && state.tableSort) {

        field.sortOrder = state.sortedInfo.columnKey === field.dataIndex &&
          state.sortedInfo.order

        /* if (field.dataIndex === 'code' && !state.sortedInfo.columnKey) {
          field.sortOrder = 'descend'
        } */
        if (state.sortedInfo.columnKey === field.dataIndex) {
          field.defaultSortOrder = state.tableSort.sorttype === 1 ? 'ascend' : 'descend'
        }

        // }
      }

      // field.scopedSlots = { customRender: fieldkey }
      // field.width = field.width - 16 * 2
      // field.minWidth = field.minWidth - 16 * 2
      newArr.push(field)
    }
    // console.log(newArr, allWidth)
    return {
      columns: newArr,
      width: allWidth
    }
  },
  defineFieldTit (state) {
    const { titles = {} } = state
    const title = Object.values(_.cloneDeep(titles))
    for (let i = 0; i < defaultTit.length; i++) {
      title.forEach((item, index) => {
        if (Object.keys(defaultTit[i])[0] === item.fieldkey) {
          title.splice(index, 1)
        }
        item.width = getWidth(item)
      })
    }
    return title
  }
}

const mutations = {
  SET_LOADING (state, data, name) {
    state.loading = data
  },
  SET_TABLE_SORT (state, { tableSort = {}, sorter = {} }) {
    state.tableSort = Object.assign({}, tableSort)
    state.sortedInfo = sorter
  },
  SET_LIST_DATA (state, data) {
    state.list = data
  },
  SET_MORE_LIST_DATA (state, data) {
    state.list.forEach(item => {
      for (let i = data.length - 1; i >= 0; i--) {
        if (data[i].inquiryid === item.inquiryid) {
          data.splice(i, 1)
        }
      }
    })
    state.list.push(...data)
  },
  SET_TITLES (state, data) {
    state.titles = data
  },
  SET_PAGINATION (state, data) {
    if (data.total !== undefined) {
      state.pagination.total = data.total
    }
    if (data.allCount !== undefined) {
      state.pagination.allCount = data.allCount
    }
  },
  setSearchs (state, data) {
    state.searchs = data
  },
  setCode (state, data) {
    state.code = data
  },
  CLEAR_LIST_DATA (state) {
    state.list = []
  },
  SET_SEARCH_CONFIG (state, data) {
    state.searchConfig = data
  },
  SET_VIEW_TABS (state, data) {
    if (data[0] && data[0].name && data[0].issystem === 1) {
      data[0].name = `${i18n.t('message["904"]')}`
    }
    state.viewTabs = data
  }
}

const actions = {
  /**
   *
   * @param {Object} data
   */
  async fetchList ({ state, commit }, data = {}) {
    let chain = null
    const { isFilter, isPull, viewid } = data
    !isPull && commit('SET_LIST_DATA', [])
    !isPull && commit('SET_LOADING', true)
    if (isFilter || viewid) {
      chain = await inquiryFilterList()
    } else {
      chain = await inquiryList()
    }

    chain.onSuccess(async payload => {
      const { data = {}, title = [] } = payload
      const { count = 0, list = [] } = data

      commit('SET_LOADING', false)
      !isPull && commit('SET_LIST_DATA', list)
      isPull && commit('SET_MORE_LIST_DATA', list)
      commit('SET_TITLES', title)
      commit('SET_PAGINATION', { total: parseInt(count) })
    })
    return chain
  },
  async fetchSearchConfig ({ state, commit }) {
    const chain = await inquiryListConfig().onSuccess(async payload => {
      state.searchConfig.options = payload

      if (payload && payload.length) {
        state.searchConfig.key = payload[0].fieldkey
        state.searchConfig.placeholder = `${i18n.t('message["751"]')} ${payload[0].fieldname}`
      }

      commit('SET_SEARCH_CONFIG', state.searchConfig)
    })
    return chain
  },
  async setInquiryListWidth ({ state, commit }, params) {
    const chain = await setInquiryListColumnWidth()
    chain
      .params(params)
      .config({ tip: false, warn: false })
      .fetch()
    return chain
  },
  async getView ({ state, commit }, params) {
    commit('SET_VIEW_TABS', [])
    const chain = await getView()
    return chain
      .params(params)
      .config({ tip: false })
      .onSuccess((payload = []) => {
        let arr = payload.filter(item => item.isenable && item.status !== -1)
        commit('SET_VIEW_TABS', arr)
      })
      .fetch()
  }
}
export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
